/**
 * DOM viewport screenshot helper for Report Issue (T-002).
 */

import { domToBlob } from 'modern-screenshot';

export const REPORT_ISSUE_EXCLUDE_ATTR = 'data-report-issue-exclude';

export interface DomScreenshotResult {
    blob: Blob;
    objectUrl: string;
}

function getCaptureRoot(): HTMLElement {
    return document.getElementById('base-layout') ?? document.body;
}

function shouldIncludeNode(node: Node): boolean {
    if (!(node instanceof Element)) {
        return true;
    }
    return !node.hasAttribute(REPORT_ISSUE_EXCLUDE_ATTR) && !node.closest(`[${REPORT_ISSUE_EXCLUDE_ATTR}]`);
}

/** Capture the current viewport as PNG before any report dialog is shown. */
export async function captureDomScreenshot(): Promise<DomScreenshotResult | null> {
    try {
        const blob = await domToBlob(getCaptureRoot(), {
            width: window.innerWidth,
            height: window.innerHeight,
            style: {
                width: `${window.innerWidth}px`,
                height: `${window.innerHeight}px`,
            },
            filter: shouldIncludeNode,
        });
        if (!(blob instanceof Blob)) {
            return null;
        }
        const objectUrl = URL.createObjectURL(blob);
        return { blob, objectUrl };
    } catch {
        return null;
    }
}

/** Convert a PNG blob to raw base64 (no data-URL prefix). */
export async function blobToRawBase64(blob: Blob): Promise<string> {
    const buffer = await blob.arrayBuffer();
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.length; i += 1) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}
